import { COLORS } from '@btime/constants'
import React from 'react'

import { SmallText } from '../presentation/Text'
import { useModalsActions, useModalsState } from './ModalsContext'
import FlexGrid from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'

const BreadcrumbsItem = ({ index, item }) => {
  const { index: currentIndex } = useModalsState()
  const { onGoTo } = useModalsActions()

  const label = item.label?.length > 20 ? item.label.substring(0, 15) + '...' : item.label

  return (
    <>
      {index > 0 && <Icon name="BsChevronRight" size=".8rem" color={COLORS.dark5} />}
      <Link block onClick={() => onGoTo(index)}>
        <SmallText size="xsmall" bold={index === currentIndex} color={COLORS.white}>
          {label}
        </SmallText>
      </Link>
    </>
  )
}

const Breadcrumbs = () => {
  const { history } = useModalsState()

  return (
    <FlexGrid justify="flex-start" gutter={0.1} wrap>
      {history?.map((item, index) => (
        <BreadcrumbsItem key={index} item={item} index={index} />
      ))}
    </FlexGrid>
  )
}

export default Breadcrumbs
